import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "media-item__content" }
const _hoisted_2 = {
  key: 0,
  class: "media-item__image-wrapper"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "media-item__image-wrapper"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "media-item__text-content" }
const _hoisted_7 = {
  key: 0,
  class: "media-item__loading-date"
}
const _hoisted_8 = {
  key: 1,
  class: "media-item__meta-info"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "article-teaser__text" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "article-teaser__text" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "article-teaser__text" }, null, -1)
const _hoisted_15 = { class: "media-info__title" }
const _hoisted_16 = {
  key: 0,
  class: "media-item__description"
}
const _hoisted_17 = { class: "media-item__text-long" }
const _hoisted_18 = { class: "media-item__text-short" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "button button--link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["media-item", { 'article-teaser--loading': _ctx.loading }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.item.type === 'image')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.item.mdImageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "media-item__image",
                        src: _ctx.item.mdImageUrl,
                        alt: _ctx.item.title
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.item.type === 'video')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: _ctx.videoImage,
                      class: "media-item__image",
                      alt: _ctx.item.title
                    }, null, 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.item.date) + " ", 1),
                (_ctx.item.country)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " | " + _toDisplayString(_ctx.item.country), 1))
                  : _createCommentVNode("", true),
                (_ctx.item.commodity)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " | " + _toDisplayString(_ctx.item.commodity), 1))
                  : _createCommentVNode("", true),
                (_ctx.item.videoDuration)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " | " + _toDisplayString(_ctx.item.videoDuration) + "min", 1))
                  : _createCommentVNode("", true)
              ])),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("b", _hoisted_15, _toDisplayString(_ctx.item.title), 1),
                (_ctx.item.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$truncate(_ctx.item.description)), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$truncate(_ctx.item.description, 50)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.downloadLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "media-item__download",
                      href: _ctx.downloadLink,
                      download: ""
                    }, [
                      _createVNode(_component_icon, {
                        name: "icn-download",
                        class: "media-info__download-icon"
                      }),
                      _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.item.type === 'image' ? _ctx.downloadLabel : _ctx.gotoVideoLabel), 1)
                    ], 8, _hoisted_19))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ])
  ], 2))
}